<template>
	<InstallLayout
		:show-back-btn="showBackBtn"
		:show-exit-btn="showExitBtn"
		:next-fn="goNext"
		:back-fn="goBack"
		:exit-fn="exit"
	>
		<template #rightIcon>
			<dialog-confirm-dialog
				v-if="showExitBtn"
				:confirmed="exit"
				:body="strings.install.exit"
			>
				<template #button="{ on, attrs }">
					<v-btn v-bind="attrs" icon v-on="on">
						<v-icon>fa-home</v-icon>
					</v-btn>
				</template>
			</dialog-confirm-dialog>
		</template>
	</InstallLayout>
</template>

<script>
import _ from "lodash";

import strings from "@/utils/strings";

import installRouter from "./router";
import InstallLayout from "../shared/Layout";

export default {
	router: installRouter,

	components: { InstallLayout },

	data: () => ({
		strings,
	}),

	computed: {
		showBackBtn() {
			const routeDesc = _.get(this.$route, "meta.back");
			return !_.isNil(routeDesc);
		},

		showExitBtn() {
			// Show home button on all but report screen
			return this.$route.name !== "Report";
		},
	},

	// Every time this component is mounted we want to restart from pairing
	// screen. Otherwise we'd be stuck on the report screen.
	beforeMount() {
		if (this.$route.name !== "Pairing")
			return this.$router.push({ name: "Pairing" });
	},

	async mounted() {
		await this.loadAll();
	},

	methods: {
		goNext() {
			let routeDesc = _.get(this.$route, "meta.next");
			if (_.isFunction(routeDesc)) routeDesc = routeDesc();

			if (routeDesc.useBaseRouter) return this.$root.$router.push(routeDesc);
			else return this.$router.push(routeDesc);
		},

		goBack() {
			const routeDesc = _.get(this.$route, "meta.back");
			if (routeDesc.useBaseRouter) return this.$root.$router.push(routeDesc);
			else return this.$router.push(routeDesc);
		},

		exit() {
			return this.$root.$router.push({ name: "Home" });
		},

		async loadAll() {
			// Load available devices for given community & room
			await this.$store.dispatch("devices/load");

			// Start controller connection - don't wait
			const systemId = this.$store.state.session.systemId;
			this.$store.dispatch("controller/loadLocal", systemId);
		},
	},
};
</script>
